import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';
import { mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';
import axios from 'axios';

// import reportCss from '!!raw-loader!@/features/report/styles/report.css'
import variablesCss from '!!raw-loader!@/components/ui/styles/_variables.css'
import rootReportLineStyles from '!!raw-loader!@/features/report/styles/shared/reportLine/root_report_line.css'
import layerReportLineStyles from '!!raw-loader!@/features/report/styles/shared/reportLine/layer_report_line.css'
import labelReportLineStyles from '!!raw-loader!@/features/report/styles/shared/reportLine/label_report_line.css'
import squareColorStyles from '!!raw-loader!@/features/report/styles/shared/reportLine/label/square-color.css'
import reportLineTextStyles from '!!raw-loader!@/features/report/styles/shared/text/report_line_text.css'
import labelAnnotationsStyles from '!!raw-loader!@/features/report/styles/shared/text/label_annotations.css'
import reportStyles from '!!raw-loader!@/features/report/styles/shared/report.css'

export const exporter = {
    data() {
        return {
            isSaving: false,
        }
    },
    computed: {
        ...mapGetters([
            'GET_jobTools',
            'GET_activeElem',
            'GET_reportNodes_validated',
            'GET_execMode',
            'GET_activeJob',
            'GET_initParamsToken',
        ]),
    },
    methods: {
        ...mapMutations([
            'MUT_runtimeUpdate'
        ]),
        printExam() {
            console.log('onPrint');
            const reportHtml = this.buildReportHtml();
            const printWindow = window.open('', '_blank', 'width=800,height=600');
            printWindow.document.write(reportHtml);
            printWindow.document.head.innerHTML = `
            <style>
            ${variablesCss}
            ${rootReportLineStyles}
            ${layerReportLineStyles}
            ${labelReportLineStyles}
            ${squareColorStyles}
            ${reportLineTextStyles}
            ${labelAnnotationsStyles}
            ${reportStyles}
            </style>`;
        },
        buildCamadasAnotacoes() {
            const svgTools = document.getElementById('svg_tools').cloneNode(true);
            svgTools.setAttribute('viewBox', '0 0 ' + this.GET_activeElem.dim.width + ' ' + this.GET_activeElem.dim.height);
            // const imageElement = document.createElementNS('http://www.w3.org/2000/svg', 'image');
            // imageElement.setAttribute('href', this.GET_activeElem.img.src);
            // imageElement.setAttribute('data-id', 'imagem-laudo');
            // imageElement.setAttribute('width', this.GET_activeElem.dim.width);
            // imageElement.setAttribute('height', this.GET_activeElem.dim.height);
            // svgTools.insertBefore(imageElement, svgTools.firstChild);

            const reportLabelNodes = this.GET_reportNodes_validated.filter(reportNode => reportNode.layout.type == gConsts.node.layout.types.LABEL);
            return reportLabelNodes.map(reportLabelNode => {
                const labelSvg = svgTools.cloneNode(true);

                const labelToolElements = labelSvg.querySelectorAll('g.tool_container[data-label="' + reportLabelNode.id + '"]')
                if (labelToolElements.length == 0)
                    return {
                        id: reportLabelNode.id,
                        caption: reportLabelNode.layout.caption,
                        color: reportLabelNode.layout.color,
                        svg: null
                    };

                // const labelLocations = reportLabelNode.annotation.list
                //     .reduce((acc, annotation) => {
                //         acc.regioesAnatomicas.push(...(annotation.localizacao?.regioesAnatomicas || []).map(regiao => regiao.id));
                //         acc.dentes.push(...(annotation.localizacao?.dentes || []).map(dente => dente.id));
                //         return acc;
                //     }, {
                //         regioesAnatomicas: [],
                //         dentes: [],
                //     });

                const labelLocations = {
                    regioesAnatomicas: [],
                    dentes: [],
                };

                labelToolElements.forEach(toolElement => {
                    toolElement.style.display = 'inline';
                    toolElement.style.strokeWidth = 2;
                    toolElement.style.opacity = 1;
                    toolElement.style.fillOpacity = 0.4;
                    const handleElement = toolElement.querySelector('#g_tool_handles');
                    if (handleElement) {
                        handleElement.remove();
                    }
                    const toolLabelElement = toolElement.querySelector('.tool-label');
                    if (toolLabelElement) {
                        toolLabelElement.remove();
                    }
                    toolElement.querySelectorAll('circle.tool_svgElem')
                        .forEach(circleElement => {
                            circleElement.setAttribute('r', '20px');
                        });
                });

                labelSvg.querySelectorAll('g.tool_container:not([data-label="' + reportLabelNode.id + '"])')
                    .forEach(toolElement => {
                        const isLabelLocation = (toolElement.id.startsWith('tool_curv') && labelLocations.dentes.includes(toolElement.getAttribute('data-label')))
                            || (toolElement.id.startsWith('tool_path') && labelLocations.regioesAnatomicas.includes(toolElement.getAttribute('data-label')));
                        if (isLabelLocation) {
                            toolElement.style.display = 'inline';
                            toolElement.style.opacity = 0.2;
                            toolElement.style.fillOpacity = 1;
                            const handleElement = toolElement.querySelector('#g_tool_handles');
                            if (handleElement) {
                                handleElement.remove();
                            }
                            const toolLabelElement = toolElement.querySelector('.tool-label');
                            if (toolLabelElement) {
                                toolLabelElement.remove();
                            }
                            return;
                        }
                        toolElement.remove();
                    });

                return {
                    id: reportLabelNode.id,
                    caption: reportLabelNode.layout.caption,
                    color: reportLabelNode.layout.color,
                    svg: labelSvg.outerHTML,
                };
            })
                .filter(item => item?.svg)
        },
        buildReportHtml() {
            const reportContent = document.getElementById('relatorio');
            if (!reportContent)
                return;
            const clonedReportContent = reportContent.cloneNode(true);
            clonedReportContent.setAttribute('data-exec-mode', 'view');
            clonedReportContent.querySelectorAll('*').forEach(element => {
                const attributes = Array.from(element.attributes);
                attributes.forEach(attr => {
                    if (attr.name.startsWith('data-v-')) {
                        element.removeAttribute(attr.name);
                    }
                    if (attr.name.startsWith('annotationstext')) {
                        element.removeAttribute(attr.name);
                    }
                });
            });
            clonedReportContent.querySelectorAll('span.custom-line-placeholder').forEach(element => {
                element.remove();
            });
            clonedReportContent.classList.add('radiobot-variables')
            let reportHTML = clonedReportContent.outerHTML;
            reportHTML = reportHTML.replace(/<!---->/g, '')

            return reportHTML;
        },
        async buildJobReport() {
            return new Promise((resolve, reject) => {
                const currentExecMode = this.GET_execMode;
                if (currentExecMode != gConsts.rt.execModes.VIEW) {
                    console.log('MUT_runtimeUpdate', { execMode: gConsts.rt.execModes.VIEW });
                    this.MUT_runtimeUpdate({ execMode: gConsts.rt.execModes.VIEW });
                }

                this.$nextTick(() => {
                    const reportNodes = this.GET_reportNodes_validated.map(reportNode => {
                        const reportNodeObject = reportNode.toObject();
                        if (reportNodeObject.info && reportNodeObject.info.insertionType == 'auto' && reportNodeObject.info.validated)
                            reportNodeObject.info.insertionType = 'manual';
                        return reportNodeObject;
                    });
                    const camadasAnotacoes = this.buildCamadasAnotacoes();
        
                    const reportHtml = this.buildReportHtml();
        
                    const report = {
                        nodes: reportNodes,
                        annotation_layers: camadasAnotacoes,
                        html: reportHtml
                    }
        
                    if (currentExecMode != gConsts.rt.execModes.VIEW) {
                        this.MUT_runtimeUpdate({ execMode: currentExecMode });
                    }

                    resolve(report);
                });
            });
        },
        async saveExam() {
            if (!this.GET_activeElem?.dim) {
                return;
            }
            this.isSaving = true;
            const report = await this.buildJobReport();
            
            const savedJob = _.cloneDeep(this.GET_activeJob);
            delete savedJob.state
            delete savedJob.metrics
            savedJob['info'] = {
                appId: 'RadioBot',
                projId: 'project_rBot_laudoPadrao',
            }
            savedJob.report = report;

            await this.requestSaveApi(savedJob);
            this.isSaving = false;

            setTimeout(() => {
                window.close();
            }, 1000)
        },

        async requestSaveApi(savedJob) {
            try {
                const body = {
                    'action': 'save',
                    'data': savedJob
                }
                const response = await axios.post(gConsts.setup.io.radiobot.backend.url.dev, body, {
                    headers: {
                        'Authorization': this.GET_initParamsToken
                    }
                });
                if (response.data?.status != 200) {
                    throw response
                }
                evtBus.$emit('evt_toast_show', {
                    title: 'Exame salvo',
                    description: 'O exame foi salvo com sucesso',
                    variant: 'success',
                    hideDelay: 4000,
                });
            } catch (error) {
                console.error('saveApiError: ', error);
                evtBus.$emit('evt_toast_show', {
                    title: 'Falha ao salvar o exame',
                    description: error?.data?.msg || error?.data?.message || 'Não foi possível salvar o exame',
                    variant: 'error',
                    hideDelay: 6000,
                });
            }
        }
    }
}